// Função central usada por toda a navegação por teclado das dialogs de
// emissão fiscal (NFC-e/NFe): decide se o evento partiu de um campo onde o
// operador está DIGITANDO (input/textarea/select aberto/autocomplete) — nesse
// caso os atalhos numéricos (1-7) e as teclas de função (F4/F6/F12) não
// devem disparar nada, senão seria impossível digitar "17" no ID do PIX ou
// escrever um código de autorização que comece com um dígito de 1 a 7.
export const isEventoDeDigitacao = (target: EventTarget | null): boolean => {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable) return true;
  return !!target.closest('[role="combobox"], [role="listbox"], .MuiAutocomplete-root, .MuiSelect-select, .MuiPopover-root, .MuiMenu-root');
};
